var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", [
    _c("div", { staticClass: "header_box_all" }, [
      _c("div", { staticClass: "header_box" }, [
        _c(
          "div",
          [
            _c("router-link", { attrs: { to: "/" } }, [
              _c("p", { staticClass: "logo" }),
            ]),
            _c("ul", { staticClass: "ul_nav" }, [
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: `/articles/` } }, [
                    _vm._v("asdsadasdasdas"),
                  ]),
                ],
                1
              ),
            ]),
            _vm._m(0),
            _c("div", { staticClass: "header_box1" }, [
              _c("div", { staticClass: "header_box1-l" }, [
                _c("img", {
                  attrs: { src: require("./images/c.png"), alt: "" },
                }),
                _c(
                  "p",
                  [
                    _c("span", [
                      _vm._v("版权所有：西安斯奈特信息科技有限公司"),
                    ]),
                    _c(
                      "el-link",
                      {
                        attrs: {
                          underline: false,
                          href: "https://beian.miit.gov.cn/",
                          target: "_blank",
                        },
                      },
                      [_vm._v("陕ICP备1111号")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "end-all" }, [
      _c("div", { staticClass: "end-all-one" }, [_vm._v("电话：1111111")]),
      _c("div", { staticClass: "end-all-one" }, [_vm._v("邮编：710000")]),
      _c("div", { staticClass: "end-all-one" }, [_vm._v("邮件：111111")]),
      _c("div", { staticClass: "end-all-one" }, [
        _vm._v(
          "地址：陕西省西安市高新区高新一路40号万科金域国际企业总部大厦A座11708室"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }